import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerProfileEstimatedAudience.graphql';
import { Query, QueryinfluencerProfileEstimatedAudienceArgs } from '../../__generated__/globalTypes';

export const useInfluencerProfileEstimatedAudienceQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerProfileEstimatedAudienceArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerProfileEstimatedAudienceArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerProfileEstimatedAudienceLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerProfileEstimatedAudienceArgs>
): QueryResult<Query, QueryinfluencerProfileEstimatedAudienceArgs> & {
  getInfluencerProfileEstimatedAudience: LazyQueryExecFunction<Query, QueryinfluencerProfileEstimatedAudienceArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerProfileEstimatedAudience, result] = useLazyQuery<
    Query,
    QueryinfluencerProfileEstimatedAudienceArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerProfileEstimatedAudience, ...result };
};

export const useInfluencerProfileEstimatedAudiencePromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerProfileEstimatedAudience = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerProfileEstimatedAudienceArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerProfileEstimatedAudienceArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerProfileEstimatedAudience };
};
// Suspense Query Hooks
export const useInfluencerProfileEstimatedAudienceSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerProfileEstimatedAudienceArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerProfileEstimatedAudienceArgs>(QUERY, {
    ...options
  });

  return result;
};
